import React from "react";
import { Image } from "react-bootstrap";
import classes from "./Notification.module.css";
import fileSize from "../../../../assets/images/icon-file-size.png";

interface Props {
  modalClosed: () => void;
  notificationText: string;
}

const notification: React.FunctionComponent<Props> = (props) => {
  const { modalClosed, notificationText } = { ...props };

  return (
    <div className={classes.popupBody}>
      <div className={classes.closeBtn} onClick={modalClosed}>
        X
      </div>
      <Image src={fileSize} alt={fileSize} />
      <p><strong>{notificationText}</strong></p>
    </div>
  );
};
export default notification;
